import { defineComponent } from '@vue/composition-api';
import Layout from '@component/layout/mobile/share/profile/index.vue';
import Content from '@view/user/share/indexV2.vue';

export default defineComponent({
    components: {
        Layout,
        Content,
    },
});
